function cancelledSelection(host, targetIndex) {
  const notificationEvent = new CustomEvent("skapa-tab-select", {
    detail: targetIndex,
    cancelable: true
  });
  host.dispatchEvent(notificationEvent);
  return notificationEvent.defaultPrevented;
}
export {
  cancelledSelection
};
